import React, { useReducer, useEffect, useContext } from "react";
import Container from "@mui/material/Container";
import { bandsReducer } from "../../../utils/stateHandlers/reducers";
import states from "../../../utils/stateHandlers/initialStates";
import {
  AppContext,
  BandsContext,
} from "../../../utils/stateHandlers/contexts";
import { api } from "../../../utils";
import qs from "qs";
import BandsPrice from "../components/bandsComponents/BandsPrice";
import { Mobile, Default } from "../../../utils/deviceHelpers";
import ProductGalleryViewer from "../components/ProductGalleryViewer";
import Typography from "@mui/material/Typography";
import Backdrop from "@mui/material/Backdrop";
import CircularProgress from "@mui/material/CircularProgress";
import { Grid, Divider, Stack, Chip } from "@mui/material";
import formatting from "../../../utils/formatHelpers";
import { functions, constants } from "../../../utils";
import BandsFields from "../components/bandsComponents/BandsFields";
import _ from "lodash";
import BandsDetailsTable from "../components/bandsComponents/BandsDetailsTable";
import BandsSpecialInstructions from "../components/bandsComponents/BandsSpecialInstructions";
import BandsTechnicalArticles from "../components/bandsComponents/BandsTechnicalArticles";
import CustomerTestimonials from "../components/CustomerTestimonials";
import HorizontalScrollList from "../components/HorizontalScrollList";
import ReactMarkdown from "react-markdown";
import remarkGfm from "remark-gfm";
import FillerImage from "../../../assets/images/Filler-Harmony-8-1-22.gif";

export default function Bands(props) {
  const { authToken } = useContext(AppContext);
  const [bandsState, bandsDispatch] = useReducer(
    bandsReducer,
    states.initialBandsState
  );
  const {
    pageLoaded,
    productInfo,
    style,
    images,
    icons,
    productFields,
    builder,
    complex,
    complex1,
    complex2,
    complex3,
    relatedProducts,
    metalColumns,
    strapiChart,
    TopText,
    BottomText,
    ChartSizeSmall,
  } = bandsState;
  const productCode = props.match.params.ProductStyleCode;
  const twoPartStyleCode = `${props.match.params.ProductStyleCode}/${props.match.params.ProductStyleCodeSecondPart}`;
  const threePartStyleCode = `${props.match.params.ProductStyleCode}/${props.match.params.ProductStyleCodeSecondPart}/${props.match.params.ProductStyleCodeThirdPart}`;

  const frontImageUrl = constants.CMS_FRONT_IMAGE_URL;

  function setDefaultBandsFormData(band) {
    var defaults = {};
    _.forEach(band.fields, function (field) {
      if (
        field.template === "field_with_units" &&
        field.name !== "builder[product]"
      ) {
        bandsDispatch({
          type: "setBandDefaults",
          field: field.name,
          payload: field.default,
        });
        bandsDispatch({
          type: "setBandDefaults",
          field: "builder[quantity_unit]",
          payload: "EA",
        });
        defaults = {
          ...defaults,
          [field.name]: field.default,
          "builder[quantity_unit]": "EA",
        };
      } else if (field.name !== "builder[product]") {
        bandsDispatch({
          type: "setBandDefaults",
          field: field.name,
          payload: field.default,
        });
        defaults = {
          ...defaults,
          [field.name]: field.default,
        };
      }
    });
    bandsDispatch({
      type: "setBandDefaults",
      field: "builder[product]",
      payload: band.product,
    });
    bandsDispatch({
      type: "setBandDefaults",
      field: "builder[dimension]",
      payload: band.dimension,
    });
    defaults = {
      ...defaults,
      "builder[product]": band.product,
      "builder[dimension]": band.dimension,
    };
    return defaults;
  }

  function sortBandFields(fields) {
    const builderArray = [];
    const complexArray = [];
    const complex1Array = [];
    const complex2Array = [];
    const complex3Array = [];

    _.forEach(fields, function (field) {
      if (_.startsWith(field.name, "builder")) {
        builderArray.push(field);
      } else if (_.startsWith(field.name, "complex[1]")) {
        complex1Array.push(field);
      } else if (_.startsWith(field.name, "complex[2]")) {
        complex2Array.push(field);
      } else if (_.startsWith(field.name, "complex[3]")) {
        complex3Array.push(field);
      } else {
        complexArray.push(field);
      }
    });
    bandsDispatch({
      type: "setBandFieldCategories",
      payload: {
        builder: builderArray,
        complex: complexArray,
        complex1: complex1Array,
        complex2: complex2Array,
        complex3: complex3Array,
      },
    });
  }

  function getInitialPrice(bandDefaults) {
    const query = qs.stringify(bandDefaults);
    if (authToken) {
      api.fetchBandPrice(`quickorder/price`, query).then((response) => {
        bandsDispatch({ type: "setPrice", payload: response.data });
        bandsDispatch({ type: "setPriceLoaded", payload: true });
      });
    }
  }

  function getPrice() {
    const query = qs.stringify(productInfo);
    if (authToken) {
      api.fetchBandPrice(`quickorder/price`, query).then((response) => {
        bandsDispatch({ type: "updatePrice", payload: response.data });
        bandsDispatch({ type: "setPriceLoaded", payload: true });
      });
    }
  }

  useEffect(() => {
    bandsDispatch({ type: "setPageLoaded", payload: false });
    bandsDispatch({ type: "setPriceLoaded", payload: false });
    api
      .fetch(
        `quickorder/form?style=${
          props.match.params.ProductStyleCodeThirdPart
            ? threePartStyleCode
            : props.match.params.ProductStyleCodeSecondPart
            ? twoPartStyleCode
            : productCode
        }`
      )
      .then((response) => {
        const bandsDefaults = setDefaultBandsFormData(response.data);
        sortBandFields(response.data.fields);
        bandsDispatch({ type: "setBandInfo", payload: response.data });
        functions.storeRecentlyViewed(response.data);
        bandsDispatch({ type: "setPageLoaded", payload: true });
        getInitialPrice(bandsDefaults);
      });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.match.params.ProductStyleCode]);

  useEffect(() => {
    if (authToken && pageLoaded) {
      bandsDispatch({ type: "setPriceLoaded", payload: false });
      getPrice();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [productInfo]);

  return (
    <BandsContext.Provider value={{ bandsState, bandsDispatch }}>
      {!pageLoaded ? (
        <Backdrop
          sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
          open={true}
        >
          <CircularProgress color="inherit" />
        </Backdrop>
      ) : (
        <Container maxWidth="xl">
          <Mobile>
            <Stack spacing={2} sx={{ marginTop: "7rem" }}>
              <Stack spacing={1} className="center">
                <Typography variant="h4">{style}</Typography>
                <Typography>
                  {productInfo.description &&
                    formatting["decodeHtml"](productInfo.description)}
                </Typography>
                <Stack direction="row" spacing={1}>
                  {icons &&
                    icons.map((icons, key) => (
                      <Typography key={icons} className="icons">
                        {functions.getIcons(icons)}
                      </Typography>
                    ))}
                </Stack>
              </Stack>
              <Divider flexItem />
              <ProductGalleryViewer images={images} />
              <Divider flexItem sx={{ paddingBottom: ".2rem" }} />
              <Stack spacing={2} sx={{ marginBottom: "8rem" }}>
                {productFields &&
                  productFields.map((field) => {
                    return <BandsFields field={field} key={field.name} />;
                  })}
                <BandsSpecialInstructions />
                <BandsPrice />
                <Typography variant="h2" sx={{ marginTop: "2rem" }}>
                  Other Items You May Like
                </Typography>
                {relatedProducts && (
                  <HorizontalScrollList
                    loadedStyles={relatedProducts}
                    related={true}
                  />
                )}
                {strapiChart && (
                  <>
                    <Typography variant="h2" sx={{ marginTop: "2rem" }}>
                      Product Series
                    </Typography>
                    <img
                      src={`${frontImageUrl}${strapiChart.data.attributes.url}`}
                      width="100%"
                      alt="banner"
                    />
                  </>
                )}
                <BandsTechnicalArticles />
                <CustomerTestimonials />
                <Typography variant="h2" sx={{ marginTop: "2rem" }}>
                  Recently Viewed
                </Typography>
                {props.RecentlyViewed && (
                  <HorizontalScrollList loadedStyles={props.RecentlyViewed} />
                )}
              </Stack>
            </Stack>
          </Mobile>
          <Default>
            <Grid container spacing={6} sx={{ marginBottom: "1rem" }}>
              <Grid item xs={5} sx={{ borderRight: "2px solid #e3e3e3" }}>
                <Stack>
                  <ProductGalleryViewer images={images} />
                  <BandsDetailsTable />
                </Stack>
              </Grid>
              <Grid item xs={4}>
                <Stack spacing={1} sx={{ marginBottom: ".5rem" }}>
                  <Typography variant="h4">{style}</Typography>
                  <Typography>
                    {productInfo.description &&
                      formatting["decodeHtml"](productInfo.description)}
                  </Typography>
                  <Stack direction="row" spacing={1}>
                    {icons &&
                      icons.map((icons, key) => (
                        <Typography key={icons} className="icons">
                          {functions.getIcons(icons)}
                        </Typography>
                      ))}
                  </Stack>
                </Stack>
                <Stack spacing={2}>
                  <Divider flexItem sx={{ marginBottom: "2rem" }}>
                    <Chip
                      label={<Typography variant="h6">General</Typography>}
                      sx={{ backgroundColor: "unset" }}
                    />
                  </Divider>
                  {builder &&
                    builder.map((field) => {
                      return (
                        <BandsFields
                          field={field}
                          key={`${field.name}${field.default}`}
                        />
                      );
                    })}
                  {complex &&
                    complex.map((field) => {
                      return (
                        <BandsFields
                          field={field}
                          key={`${field.name}${field.default}`}
                        />
                      );
                    })}
                  <Divider flexItem sx={{ marginBottom: "2rem" }}>
                    <Chip
                      label={<Typography variant="h6">Part One</Typography>}
                      sx={{ backgroundColor: "unset" }}
                    />
                  </Divider>
                  {complex1 &&
                    complex1.map((field) => {
                      return (
                        <BandsFields
                          field={field}
                          key={`${field.name}${field.default}`}
                        />
                      );
                    })}
                  {complex2 && complex2.length > 0 && (
                    <Divider flexItem sx={{ marginBottom: "2rem" }}>
                      <Chip
                        label={<Typography variant="h6">Part Two</Typography>}
                        sx={{ backgroundColor: "unset" }}
                      />
                    </Divider>
                  )}

                  {complex2 &&
                    complex2.map((field) => {
                      return (
                        <BandsFields
                          field={field}
                          key={`${field.name}${field.default}`}
                        />
                      );
                    })}
                  {complex3 && complex3.length > 0 && (
                    <Divider flexItem sx={{ marginBottom: "2rem" }}>
                      <Chip
                        label={<Typography variant="h6">Part Three</Typography>}
                        sx={{ backgroundColor: "unset" }}
                      />
                    </Divider>
                  )}

                  {complex3 &&
                    complex3.map((field) => {
                      return (
                        <BandsFields
                          field={field}
                          key={`${field.name}${field.default}`}
                        />
                      );
                    })}
                  <BandsSpecialInstructions />
                </Stack>
              </Grid>
              <Grid item xs={3}>
                <BandsPrice />
              </Grid>
            </Grid>
            {metalColumns && (
              <>
                <Divider flexItem />
                <Grid container spacing={20} justifyContent="center">
                  <Grid item xs={4}>
                    <Typography variant="staticText">
                      <ReactMarkdown remarkPlugins={[remarkGfm]}>
                        {metalColumns.left}
                      </ReactMarkdown>
                    </Typography>
                  </Grid>
                  <Grid item xs={4}>
                    <Typography variant="staticText">
                      <ReactMarkdown remarkPlugins={[remarkGfm]}>
                        {metalColumns.middle}
                      </ReactMarkdown>
                    </Typography>
                  </Grid>
                  <Grid item xs={4}>
                    <Typography variant="staticText">
                      <ReactMarkdown remarkPlugins={[remarkGfm]}>
                        {metalColumns.right}
                      </ReactMarkdown>
                    </Typography>
                  </Grid>
                </Grid>
              </>
            )}
            {strapiChart && (
              <>
                <Typography variant="h2" sx={{ marginTop: "2rem" }}>
                  {productCode === "GR"
                    ? "Casting Grain Specifications"
                    : "Product Series"}
                </Typography>
                {TopText && (
                  <Typography variant="staticText">
                    <ReactMarkdown remarkPlugins={[remarkGfm]}>
                      {TopText}
                    </ReactMarkdown>
                  </Typography>
                )}
                {ChartSizeSmall ? (
                  <Grid
                    container
                    direction="row"
                    justifyContent="center"
                    alignItems="center"
                  >
                    <Grid item xs={6} className="center">
                      <img
                        src={`${frontImageUrl}${strapiChart.data.attributes.url}`}
                        width="100%"
                        alt="banner"
                      />
                    </Grid>
                    <Grid item xs={6} className="center">
                      <img src={FillerImage} alt="filler for small table" />
                    </Grid>
                  </Grid>
                ) : (
                  <img
                    src={`${frontImageUrl}${strapiChart.data.attributes.url}`}
                    width="100%"
                    alt="banner"
                  />
                )}
                {BottomText && (
                  <Typography variant="staticText">
                    <ReactMarkdown remarkPlugins={[remarkGfm]}>
                      {BottomText}
                    </ReactMarkdown>
                  </Typography>
                )}
              </>
            )}
            <Typography variant="h2" sx={{ marginTop: "2rem" }}>
              Other Items You May Like
            </Typography>
            {relatedProducts && (
              <HorizontalScrollList
                loadedStyles={relatedProducts}
                related={true}
              />
            )}
            <div>
              <BandsTechnicalArticles />
              <CustomerTestimonials />
            </div>
            <Typography variant="h2" sx={{ marginTop: "2rem" }}>
              Recently Viewed
            </Typography>
            {props.RecentlyViewed && (
              <HorizontalScrollList loadedStyles={props.RecentlyViewed} />
            )}
          </Default>
        </Container>
      )}
    </BandsContext.Provider>
  );
}
